export default __webpack_public_path__ + "assets/custom-item-picture.d58391c64f76464075ec69611375f91b.png";